import type { QueryClient } from '@tanstack/react-query';
import type { DocumentSectionsResponse } from '../../../services/documents/DocumentRepository';
import { calculateSectionsWithSubtotals } from 'pages/editor/useSectionsForPreview.tsx';
import { QueryKeys } from 'utils/queryKeys';

// Refetches sections instead of trusting the tab's mount-time snapshot, which can go stale.
export const getFreshSectionsForSigning = async (
  queryClient: QueryClient,
  contentId: string,
  fallbackSections: DocumentSectionsResponse
): Promise<DocumentSectionsResponse> => {
  const queryKey = QueryKeys.getGridsByContentId(contentId);
  // type: 'all' — refetch even without an active observer mounted.
  await queryClient.refetchQueries({ queryKey, exact: true, type: 'all' });
  const freshRaw = queryClient.getQueryData<DocumentSectionsResponse>(queryKey);
  return calculateSectionsWithSubtotals(freshRaw ?? fallbackSections).sections;
};
